import { AfterViewInit, Directive, ElementRef, OnInit, ViewChild } from '@angular/core';

import { ScrollingService } from 'src/app/core/services/scrolling/scrolling.service';

import { ModalService } from '../modal-service/modal.service';

@Directive()
export abstract class BaseModal implements OnInit, AfterViewInit {
  @ViewChild('modalRef', { static: true }) public modalRef: ElementRef<HTMLElement> | undefined;

  public constructor(
    protected readonly modalService: ModalService,
    protected readonly scrollingService: ScrollingService
  ) {}

  public ngOnInit(): void {
    this.scrollingService.disableScrolling();
  }

  public ngAfterViewInit(): void {
    this.setModalFocus();
  }

  public onClose(): void {
    this.modalService.close();
    this.scrollingService.enableScrolling();
  }

  protected setModalFocus(): void {
    if (this.modalRef?.nativeElement) {
      this.modalRef.nativeElement.focus({
        preventScroll: true
      });
    }
  }
}
